import * as React from 'react';
import uniqBy from 'lodash/uniqBy';
import { useCurrentRefinements, useRange } from 'react-instantsearch';
import { BadgeButton } from '@grandvisionhq/iris-ui';
import { useIntl } from '@grandvisionhq/state';
import { isNumber, formatPrice } from '@grandvisionhq/utils';
import { useAlgoliaConfig } from '../../AlgoliaConfig.js';
import { getFacetOptionLabel } from '../../utils/get-facet-option-label.js';
import ClearRefinements from '../ClearRefinements/ClearRefinements.js';

const CurrentRefinements = ()=>{
    const { items: items1 , refine  } = useCurrentRefinements();
    const { facets  } = useAlgoliaConfig();
    const intl = useIntl();
    const uniqItems = React.useMemo(()=>uniqBy(items1, (item)=>item.attribute + item.label
        )
    , [
        items1
    ]);
    const refinementItems = React.useMemo(()=>{
        return uniqItems.reduce((result, item)=>{
            const facet = facets.find(({ attribute  })=>attribute === item.attribute
            );
            if (!facet || facet.hidden) {
                return result;
            }
            const element = /*#__PURE__*/ React.createElement(React.Fragment, {
                key: facet.attribute
            }, isRangeRefinement(item) ? /*#__PURE__*/ React.createElement(RangeRefinement, {
                item: item
            }) : item.refinements ? renderItems(item.refinements, facet) : null);
            return [
                ...result,
                element
            ];
        }, []);
    }, [
        uniqItems
    ]);
    return refinementItems.length > 0 ? /*#__PURE__*/ React.createElement("div", {
        className: "current-refinements",
        "data-t": "current-refinements"
    }, refinementItems, /*#__PURE__*/ React.createElement(ClearRefinements, null)) : null;
    function renderItems(items, facet) {
        return /*#__PURE__*/ React.createElement(React.Fragment, null, items.map((item)=>{
            let itemLabel = getFacetOptionLabel(facet, item.label, intl).label;
            if (facet.showLabel && facet.labelKey && intl.hasLabel(facet.labelKey)) {
                itemLabel = `${intl.getLabel(facet.labelKey || facet.id)}: ${itemLabel}`;
            }
            return /*#__PURE__*/ React.createElement(BadgeButton, {
                key: item.label,
                isSelected: true,
                isDismissable: true,
                onPress: ()=>refine(item)
            }, itemLabel);
        }));
    }
};
function RangeRefinement({ item  }) {
    const intl = useIntl();
    const { range: { max , min  } , start , refine: rangeRefine ,  } = useRange({
        attribute: item.attribute
    });
    if (!isNumber(min) || !isNumber(max) || max === min) {
        return null;
    }
    const currentRefinement = {
        min: Math.max(min, Number.isFinite(start[0]) ? start[0] : min),
        max: Math.min(max, Number.isFinite(start[1]) ? start[1] : max)
    };
    const format = (refinement)=>formatPrice({
            locale: intl.locale,
            value: Math.round(refinement / 100),
            currency: intl.currency,
            isCentAmount: false
        })
    ;
    const badgeLabel = `${format(currentRefinement.min)} - ${format(currentRefinement.max)}`;
    return /*#__PURE__*/ React.createElement(BadgeButton, {
        isSelected: true,
        isDismissable: true,
        onPress: ()=>rangeRefine([
                min,
                max
            ])
    }, badgeLabel);
}
function isRangeRefinement(refinement) {
    return refinement.refinements.some((item)=>item.type === 'numeric'
    );
}

export { CurrentRefinements };
//# sourceMappingURL=CurrentRefinements.js.map
